import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
// import Img from 'gatsby-image'
import PhotoHeader from '../../../styles/main-photo-styles';
import PhotoContainer from '../../../styles/main-photo-container-styles';

class TopBlock extends React.Component {
    render() {
      // const { html } = this.props
      return(
          <MainContainer>
            <p>Welcome to <Link to={'/'}>TrendyMoscow.com</Link>, one of the oldest online resources for travellers planning their trip to Moscow, Russia. Here you’ll get all the information and tools that will make your stay in <strong>Moscow</strong> more exciting, productive and safe. Explore Trendy Moscow’s sections dedicated to <Link to={'/attractions/'}>attractions</Link>, <Link to={'/best-restaurants-moscow/'}>restaurants</Link>, <Link to={'/moscow-nightclubs/'}>nightlife</Link> as well as various parts of Moscow.</p>
            <PhotoContainer>
              <Link to={`/attractions/`}>
                  <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/moscow-main-960.jpg" alt="moscow"/></picture>
              </Link>
              <PhotoHeader>
                  <Link to={`/attractions/`}>
                      <span>Top Things You Definitelly Have</span>
                      <br></br>
                      <span>To Do in Moscow</span>
                  </Link>
              </PhotoHeader>
            </PhotoContainer>

            {/* <FrontText html={html}/> */}
          </MainContainer>
      )
    }
}

const MainContainer = styled.div`
`;



export default TopBlock

// const mainPageTop = graphql`
//   query mainPageTop {
//     image1: file(relativePath: { eq: "main/moscow-main-960.jpg" }) {
//       ...mainPageTopImage
//     }
//     # image2: file(relativePath: { eq: "banners/vanilia.jpg" }) {
//     #   ...squareImage
//     # }
// }
// `

// export const mainPageTopImage = graphql`
//   fragment mainPageTopImage on File {
//     childImageSharp {
//       fluid(maxWidth: 960, maxHeight: 400, quality: 100 ) {
//         ...GatsbyImageSharpFluid
//       }
//     }
//   }
// `
